import { motion } from '../../theme/motion';

/**
 * FadeIn props for the nth section of a screen.
 *
 * A screen arrives as a sequence, not all at once: each section carries the
 * same short rise as the screen itself, one stagger step behind the one above
 * it. Index 0 starts immediately — the first thing on the page should not wait.
 *
 *   <FadeIn {...sectionEntrance(0)}>…header…</FadeIn>
 *   <FadeIn {...sectionEntrance(1)}>…stats…</FadeIn>
 */
export function sectionEntrance(index: number) {
  return {
    delay: index * motion.stagger.step,
    duration: motion.durations.normal,
    translateY: 10,
  } as const;
}
